import React from 'react';

import { Block, withBlockRendering } from '../common/Block.jsx';
import {
    BuilderBlock,
    BuilderControls,
    EmptyContentPlaceholder,
    EmptyPlaceholder,
    PageBottomHiddenDraggable,
    PageTopHiddenDraggable
} from '../common/builder';
import Kit from './Kit.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import Utilities from '../common/Utilities.jsx';

// Re-export Arrow for BuilderControls backward compatibility
import Arrow from '../common/Arrow.jsx';

const Builder = {
    getCurrentKitValueIndicator: (_options) => {
        const options = _options || {};
        const kitValue = Kit.Page.currentValue(options);
        if (kitValue == undefined) {
            return;
        }
        if (options.valueOnly == true) {
            return kitValue;
        }
        return <span className="config-help-kit" style={{ float: 'right' }}>Style guide value: <span style={{ textTransform: 'capitalize' }}>{kitValue}</span></span>
    },

    getSocialPlatforms: (_config) => {
        const socialPlatforms = [];
        if (!_config) {
            return socialPlatforms;
        }
        if (_config.artCloudUrl && _config.artCloudUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.ArtCloud, url: _config.artCloudUrl });
        }
        if (_config.pinterestUrl && _config.pinterestUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.Pinterest, url: _config.pinterestUrl });
        }
        if (_config.blueskyUrl && _config.blueskyUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.Bluesky, url: _config.blueskyUrl });
        }
        if (_config.twitterUrl && _config.twitterUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.Twitter, url: _config.twitterUrl });
        }
        if (_config.instagramUrl && _config.instagramUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.Instagram, url: _config.instagramUrl });
        }
        if (_config.facebookUrl && _config.facebookUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.Facebook, url: _config.facebookUrl });
        }
        if (_config.artsyUrl && _config.artsyUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.Artsy, url: _config.artsyUrl });
        }
        if (_config.artnetUrl && _config.artnetUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.Artnet, url: _config.artnetUrl });
        }
        if (_config.firstDibsUrl && _config.firstDibsUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.FirstDibs, url: _config.firstDibsUrl });
        }
        if (_config.houzzUrl && _config.houzzUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.Houzz, url: _config.houzzUrl });
        }
        if (_config.youTubeUrl && _config.youTubeUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.YouTube, url: _config.youTubeUrl });
        }
        if (_config.linkedInUrl && _config.linkedInUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.LinkedIn, url: _config.linkedInUrl });
        }
        if (_config.tikTokUrl && _config.tikTokUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.TikTok, url: _config.tikTokUrl });
        }
        if (_config.vimeoUrl && _config.vimeoUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.Vimeo, url: _config.vimeoUrl });
        }
        if (_config.whatsAppUrl && _config.whatsAppUrl.length > 0) {
            socialPlatforms.push({ platform: Name.SocialPlatform.WhatsApp, url: _config.whatsAppUrl });
        }
        return socialPlatforms;
    },

    handleBlockProps: (d, _, parentProps) => {
        if (!d.type) {
            return;
        }
        let style;
        if (parentProps && parentProps.inLayout && d.config && d.config.layout) {
            if (d.config.layout.width && d.config.layout.width.value && d.config.layout.width.value.length > 0) {
                style = { width: `${d.config.layout.width.value}${d.config.layout.width.unit}` };
            }
            if (d.config.layout.maxWidth && d.config.layout.maxWidth.value && d.config.layout.maxWidth.value.length > 0) {
                if (!style) {
                    style = {};
                }
                style.maxWidth = `${d.config.layout.maxWidth.value}${d.config.layout.maxWidth.unit}`;
            }
            if (d.config.layout.minWidth && d.config.layout.minWidth.value && d.config.layout.minWidth.value.length > 0) {
                if (!style) {
                    style = {};
                }
                style.minWidth = `${d.config.layout.minWidth.value}${d.config.layout.minWidth.unit}`;
            }
            if (style) {
                if (d.config.layout.marginLeft && d.config.layout.marginLeft.value && d.config.layout.marginLeft.value.length > 0) {
                    style.marginLeft = `${d.config.layout.marginLeft.value}${d.config.layout.marginLeft.unit}`;
                }
                if (d.config.layout.marginRight && d.config.layout.marginRight.value && d.config.layout.marginRight.value.length > 0) {
                    style.marginRight = `${d.config.layout.marginRight.value}${d.config.layout.marginRight.unit}`;
                }
            }
            if (d.config.layout.maxHeight && d.config.layout.maxHeight.value && d.config.layout.maxHeight.value.length > 0) {
                if (!style) {
                    style = {};
                }
                style.maxHeight = `${d.config.layout.maxHeight.value}${d.config.layout.maxHeight.unit}`;
                // style.overflow = 'hidden';
            }
            if (d.config.layout.minHeight && d.config.layout.minHeight.value && d.config.layout.minHeight.value.length > 0) {
                if (!style) {
                    style = {};
                }
                let unit = d.config.layout.minHeight.unit;
                if (unit == '%') {
                    unit = 'vh';
                }
                style.minHeight = `${d.config.layout.minHeight.value}${unit}`;
            }
        }
        const blockProps = {};
        let contentKey, contentTest;
        switch (d.type.value) {
            case Name.Block.Artist.SignupV1:
            case Name.Block.Cart.CardFormV1:
            case Name.Block.Cart.PromoCodeV1:
            case Name.Block.Footer.QuickLinksV1:
            case Name.Block.Footer.QuickLinksV2:
            case Name.Block.Footer.SubscribeFormV1:
                if (parentProps && parentProps.inLayout && style && style.maxWidth) {
                    style.width = '100%';
                }
                break;
            case Name.Block.ImageGallery:
                contentKey = 'images';
                contentTest = (content) => content.image && content.image.id && content.image.extension
            // Intentional fallthrough
            case Name.Block.SocialV1:
            case Name.Block.SocialV2:
                if (!contentKey) {
                    contentKey = 'social';
                    contentTest = (content) => content.platform
                }
                let hasContent = false;
                if (d.blockConfig && d.blockConfig[contentKey]) {
                    let temp;
                    for (let i = 0; i < d.blockConfig[contentKey].length; i++) {
                        temp = d.blockConfig[contentKey][i];
                        if (!temp || !contentTest || !contentTest(temp)) {
                            continue;
                        }
                        hasContent = true;
                        break;
                    }
                }
                if (!hasContent) {
                    if (!style) {
                        style = {};
                    }
                    style.width = '100%';
                }
                break;
            case Name.Block.Inventory.Image:
                if (parentProps) {
                    if (parentProps.data && parentProps.data.inventory && parentProps.data.inventory.images && parentProps.data.inventory.images.length > 1) {
                        blockProps.className = 'builder-block-tabbed';
                        switch (parentProps.pageType) {
                            case PageType.InventoryDetailModal:
                                blockProps.className += ' builder-block-inventory-slider';
                                break;
                        }
                    }
                    if (parentProps.inLayout) {
                        const className = 'builder-block-abs builder-block-abs-pad'
                        if (blockProps.className) {
                            blockProps.className += ` ${className}`
                        } else {
                            blockProps.className = className
                        }
                    }
                }
            // Intentional fallthrough
            case Name.Block.Slider.Carousel:
                if (d.config.layout.marginBottom && d.config.layout.marginBottom.value && d.config.layout.marginBottom.value.length > 0) {
                    if (!style) {
                        style = {};
                    }
                    style.marginBottom = `${d.config.layout.marginBottom.value}${d.config.layout.marginBottom.unit}`;
                }
                if (d.config.layout.marginTop && d.config.layout.marginTop.value && d.config.layout.marginTop.value.length > 0) {
                    if (!style) {
                        style = {};
                    }
                    style.marginTop = `${d.config.layout.marginTop.value}${d.config.layout.marginTop.unit}`;
                }
                blockProps.renderControls = false;
                break;
            case Name.Block.Accordion:
                blockProps.className = 'builder-block-tabbed builder-block-accordion';
                blockProps.renderControls = false;
                break;
            case Name.Block.Artist.Signup.Input.Email:
            case Name.Block.Artist.Signup.Input.Name:
            case Name.Block.Cart.CardForm.Input.BillingAddress.AddressLine1:
            case Name.Block.Cart.CardForm.Input.BillingAddress.AddressLine2:
            case Name.Block.Cart.CardForm.Input.BillingAddress.City:
            case Name.Block.Cart.CardForm.Input.BillingAddress.Country:
            case Name.Block.Cart.CardForm.Input.BillingAddress.State:
            case Name.Block.Cart.CardForm.Input.BillingAddress.Zip:
            case Name.Block.Cart.CardForm.Input.CardNumber:
            case Name.Block.Cart.CardForm.Input.Email:
            case Name.Block.Cart.CardForm.Input.ExpirationDate:
            case Name.Block.Cart.CardForm.Input.FirstName:
            case Name.Block.Cart.CardForm.Input.LastName:
            case Name.Block.Cart.CardForm.Input.Notes:
            case Name.Block.Cart.CardForm.Input.Phone:
            case Name.Block.Cart.CardForm.Input.SecurityCode:
            case Name.Block.Cart.CardForm.Input.ShippingAddress.AddressLine1:
            case Name.Block.Cart.CardForm.Input.ShippingAddress.AddressLine2:
            case Name.Block.Cart.CardForm.Input.ShippingAddress.City:
            case Name.Block.Cart.CardForm.Input.ShippingAddress.Country:
            case Name.Block.Cart.CardForm.Input.ShippingAddress.State:
            case Name.Block.Cart.CardForm.Input.ShippingAddress.Zip:
            case Name.Block.Cart.LineItem.Cell.InventoryLineItemQuantityInput:
            case Name.Block.Cart.PromoCode.Input.Code:
            case Name.Block.Cart.StripeElements:
            case Name.Block.Contact.Form.Input.Address.City:
            case Name.Block.Contact.Form.Input.Address.Country:
            case Name.Block.Contact.Form.Input.Address.Line1:
            case Name.Block.Contact.Form.Input.Address.Line2:
            case Name.Block.Contact.Form.Input.Address.State:
            case Name.Block.Contact.Form.Input.Address.Zip:
            case Name.Block.Contact.Form.Input.Email:
            case Name.Block.Contact.Form.Input.Message:
            case Name.Block.Contact.Form.Input.Name:
            case Name.Block.Contact.Form.Input.Phone:
            case Name.Block.Contact.Form.Input.Subject:
            case Name.Block.Footer.SubscribeForm.Input.Address.City:
            case Name.Block.Footer.SubscribeForm.Input.Address.Country:
            case Name.Block.Footer.SubscribeForm.Input.Address.Line1:
            case Name.Block.Footer.SubscribeForm.Input.Address.Line2:
            case Name.Block.Footer.SubscribeForm.Input.Address.State:
            case Name.Block.Footer.SubscribeForm.Input.Address.Zip:
            case Name.Block.Footer.SubscribeForm.Input.Email:
            case Name.Block.Footer.SubscribeForm.Input.Name:
            case Name.Block.Footer.SubscribeForm.Input.Phone:
            case Name.Block.Header.SearchBar.Input.Search:
            case Name.Block.InquireForm.Input.Address.City:
            case Name.Block.InquireForm.Input.Address.Country:
            case Name.Block.InquireForm.Input.Address.Line1:
            case Name.Block.InquireForm.Input.Address.Line2:
            case Name.Block.InquireForm.Input.Address.State:
            case Name.Block.InquireForm.Input.Address.Zip:
            case Name.Block.InquireForm.Input.Email:
            case Name.Block.InquireForm.Input.Message:
            case Name.Block.InquireForm.Input.Name:
            case Name.Block.InquireForm.Input.Phone:
            case Name.Block.OfferForm.Input.Email:
            case Name.Block.OfferForm.Input.Name:
            case Name.Block.OfferForm.Input.Phone:
            case Name.Block.OfferForm.Input.PriceFixed:
            case Name.Block.OfferForm.Input.PricePercent:
            case Name.Block.PasswordForm.Input.Password:
            case Name.Block.SubscribeForm.Input.Address.City:
            case Name.Block.SubscribeForm.Input.Address.Country:
            case Name.Block.SubscribeForm.Input.Address.Line1:
            case Name.Block.SubscribeForm.Input.Address.Line2:
            case Name.Block.SubscribeForm.Input.Address.State:
            case Name.Block.SubscribeForm.Input.Address.Zip:
            case Name.Block.SubscribeForm.Input.Email:
            case Name.Block.SubscribeForm.Input.Name:
            case Name.Block.SubscribeForm.Input.Phone:
                blockProps.className = 'builder-block-tabbed builder-block-input';
                blockProps.renderControls = false;
                break;
            case Name.Block.Artist.TabsV1:
            case Name.Block.Artist.TabsV2:
            case Name.Block.Columns:
            case Name.Block.HoverContent:
            case Name.Block.Show.TabsV1:
            case Name.Block.Show.TabsV2:
            case Name.Block.Tabs:
                blockProps.className = 'builder-block-tabbed';
                blockProps.renderControls = false;
                break;
            case Name.Block.Cart.ApplePayButton:
                // ApplePay button doesn't have a hover state, so it doesn't get a fancy class like the other buttons
                break;
            case Name.Block.Artist.Signup.SubmitButtonV1:
            case Name.Block.Artist.Signup.SubmitButtonV2:
            case Name.Block.ButtonV2:
            case Name.Block.ButtonV3:
            case Name.Block.Cart.PromoCode.SubmitButtonV1:
            case Name.Block.Cart.PromoCode.SubmitButtonV2:
            case Name.Block.Cart.PurchaseButtonV1:
            case Name.Block.Cart.PurchaseButtonV2:
            case Name.Block.Contact.Form.SubmitButtonV1:
            case Name.Block.Contact.Form.SubmitButtonV2:
            case Name.Block.CookiePolicy.Button.Accept:
            case Name.Block.CookiePolicy.Button.Reject:
            case Name.Block.Footer.SubscribeForm.SubmitButtonV1:
            case Name.Block.Footer.SubscribeForm.SubmitButtonV2:
            case Name.Block.Header.SearchBar.SubmitButtonV1:
            case Name.Block.Header.SearchBar.SubmitButtonV2:
            case Name.Block.InquireForm.SubmitButtonV1:
            case Name.Block.InquireForm.SubmitButtonV2:
            case Name.Block.Inventory.Button.ArtistProfileV1:
            case Name.Block.Inventory.Button.ArtistProfileV2:
            case Name.Block.Inventory.Button.InquireV2:
            case Name.Block.Inventory.Button.InquireV3:
            case Name.Block.Inventory.Button.OfferV2:
            case Name.Block.Inventory.Button.OfferV3:
            case Name.Block.Inventory.Button.PurchaseV2:
            case Name.Block.Inventory.Button.PurchaseV3:
            case Name.Block.OfferForm.SubmitButtonV1:
            case Name.Block.OfferForm.SubmitButtonV2:
            case Name.Block.PasswordForm.SubmitButton:
            case Name.Block.PurchasePopup.CartButtonV1:
            case Name.Block.PurchasePopup.CartButtonV2:
            case Name.Block.PurchasePopup.ContinueButtonV1:
            case Name.Block.PurchasePopup.ContinueButtonV2:
            case Name.Block.PurchasePopup.DropDown.DimensionsV1:
            case Name.Block.PurchasePopup.DropDown.DimensionsV2:
            case Name.Block.PurchasePopup.DropDown.Framing:
            case Name.Block.PurchasePopup.DropDown.MediaV1:
            case Name.Block.PurchasePopup.DropDown.MediaV2:
            case Name.Block.PurchasePopup.DropDown.PriceV1:
            case Name.Block.PurchasePopup.DropDown.PriceV2:
            case Name.Block.PurchasePopup.SubmitButtonV1:
            case Name.Block.PurchasePopup.SubmitButtonV2:
            case Name.Block.Show.Cell.DetailButtonV2:
            case Name.Block.Show.Cell.DetailButtonV3:
            case Name.Block.SignUpButtonV2:
            case Name.Block.SignUpButtonV3:
            case Name.Block.SubscribeForm.SubmitButtonV1:
            case Name.Block.SubscribeForm.SubmitButtonV2:
                blockProps.className = 'builder-block-tabbed builder-block-button';
                blockProps.renderControls = false;
                break;
            case Name.Block.Artist.List:
            case Name.Block.Artist.Inventory.ListV1:
            case Name.Block.Artist.Inventory.ListV2:
            case Name.Block.Artist.Inventory.ListV3:
            case Name.Block.Inventory.ListV1:
            case Name.Block.Inventory.ListV2:
            case Name.Block.Inventory.ListV3:
            case Name.Block.Inventory.RelatedV1:
            case Name.Block.Inventory.RelatedV2:
            case Name.Block.Inventory.RelatedV3:
            case Name.Block.Inventory.RecentlyViewed.List:
            case Name.Block.Show.Inventory.ListV1:
            case Name.Block.Show.Inventory.ListV2:
            case Name.Block.Show.Inventory.ListV3:
                blockProps.renderControls = false;
                break;
            case Name.Block.Artist.ImageV2:
            case Name.Block.Footer.LogoV2:
            case Name.Block.Header.LogoV2:
            case Name.Block.ImageV2:
            case Name.Block.Show.ImageV2:
                if (parentProps.inLayout) {
                    if (d.config.layout.marginBottom && d.config.layout.marginBottom.value && d.config.layout.marginBottom.value.length > 0) {
                        if (!style) {
                            style = {};
                        }
                        style.marginBottom = `${d.config.layout.marginBottom.value}${d.config.layout.marginBottom.unit}`;
                    }
                    if (d.config.layout.marginTop && d.config.layout.marginTop.value && d.config.layout.marginTop.value.length > 0) {
                        if (!style) {
                            style = {};
                        }
                        style.marginTop = `${d.config.layout.marginTop.value}${d.config.layout.marginTop.unit}`;
                    }
                    blockProps.className = 'builder-block-abs'
                }
                break;
            case Name.Block.Parallax:
                blockProps.renderControls = false;
                break;
        }
        blockProps.style = style;
        return blockProps;
        // return { className, style };
    },

    handleCellBlockProps: (d, _, parentProps) => {
        if (!d.type) {
            return;
        }
        let blockProps;
        switch (d.type.value) {
            case Name.Block.Artist.Cell.Image:
            case Name.Block.Blog.Cell.Image:
            case Name.Block.Inventory.Cell.Image:
            case Name.Block.SearchResult.Cell.Image.Artist:
            case Name.Block.SearchResult.Cell.Image.Blog:
            case Name.Block.SearchResult.Cell.Image.Inventory:
            case Name.Block.SearchResult.Cell.Image.Show:
            case Name.Block.Show.Cell.Image:
                if (d.config && d.config.layout) {
                    if (!blockProps) {
                        blockProps = { style: {} };
                    } else if (!blockProps.style) {
                        blockProps.style = {};
                    }
                    const hasWidth = d.config.layout.width && d.config.layout.width.value && d.config.layout.width.value.length > 0;
                    if (hasWidth) {
                        blockProps.style.width = `${d.config.layout.width.value}${d.config.layout.width.unit}`;
                    }
                    const hasMaxHeight = d.config.layout.maxHeight && d.config.layout.maxHeight.value && d.config.layout.maxHeight.value.length > 0;
                    if (parentProps.inLayout) {
                        // blockProps.style.flexDirection = 'row';
                        if (!hasMaxHeight && !hasWidth) {
                            blockProps.style.width = '100%';
                        }
                    } else if (hasWidth) {
                        blockProps.style.margin = Block.marginForAlignment(d.config.layout.alignItems);
                    }
                }
                break;
            case Name.Block.Artist.Cell.Text:
            case Name.Block.Blog.Cell.Text:
            case Name.Block.Inventory.Cell.Text:
            case Name.Block.SearchResult.Cell.Text.Artist:
            case Name.Block.SearchResult.Cell.Text.Blog:
            case Name.Block.SearchResult.Cell.Text.Inventory:
            case Name.Block.SearchResult.Cell.Text.Show:
            case Name.Block.Show.Cell.Text:
            case Name.Block.Text:
                if (d.config && d.config.layout) {
                    if (parentProps.inLayout && d.config.layout.minWidth && d.config.layout.minWidth.value && d.config.layout.minWidth.value.length > 0 && d.config.layout.minWidth.unit == '%') {
                        if (!blockProps) {
                            blockProps = { style: {} };
                        } else if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        blockProps.style.minWidth = `${d.config.layout.minWidth.value}${d.config.layout.minWidth.unit}`;
                    }
                    if (!parentProps.inLayout && d.config.layout.maxWidth && d.config.layout.maxWidth.value && d.config.layout.maxWidth.value.length > 0) {
                        if (!blockProps) {
                            blockProps = { style: {} };
                        } else if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        blockProps.style.maxWidth = `${d.config.layout.maxWidth.value}${d.config.layout.maxWidth.unit}`;
                        blockProps.style.width = '100%';
                    }
                }
                break;
        }
        return blockProps;
    }
}

function BuilderPagerControls(props) {
    const label = props.label ? `${props.label}:` : 'PAGING PREVIEW:';
    let style;
    if (props.inLayout) {
        style = { marginLeft: '-2px', width: 'calc(100% - 6px)' };
    }
    let after, before;
    if (!props.disabled) {
        after = <Arrow direction="next" onClick={props.onPageChange} />
        before = <Arrow direction="prev" onClick={props.onPageChange} />
    }
    return <BuilderControls after={after} before={before} label={label} style={style} onBlockMove={props.onBlockMove} />
}

function _EditorContainer(props) {
    const renderedBlocks = props.onBlockRendering(props.pageType, props.blocks || [], props.blockPropsHandler, props.builderBlockPropsHandler);
    let containerProps = props.containerProps;

    if (props.onContainerProps) {
        containerProps = props.onContainerProps();
    }
    let style, topHiddenOffset;
    if (containerProps && containerProps.config) {
        style = {};

        let configProps;
        for (let configName in containerProps.config) {
            configProps = containerProps.config[configName];
            Block.mapStyleConfigProps(style, configProps, (propName, propValue, propUnit) => {
                let returnValue;
                if (props.onMapStyleConfigProp) {
                    returnValue = props.onMapStyleConfigProp(configName, propName, propValue, propUnit, style);
                }
                if (returnValue) {
                    return true;
                }
                switch (propName) {
                    case 'paddingTop':
                        topHiddenOffset = propValue;
                        break;
                }
            });
        }
    }
    if (props.onMapStyleConfigComplete) {
        style = props.onMapStyleConfigComplete(style);
    }
    let className = props.className || '';
    if (props.builder) {
        className += ' builder';
        if (props.editor) {
            className += ' builder-editor'
            if (props.updateBackgroundColor != false) {
                if ((!style || !style.backgroundColor) && props.backgroundColor) {
                    if (!style) {
                        style = {};
                    }
                    style.backgroundColor = props.backgroundColor;
                }
            }
        }
        if (props.dragging) {
            className += ' dragging';
        }
    }
    let containerStyle = props.style || {};
    let content = (
        <React.Fragment>
            {
                props.editor &&
                <PageTopHiddenDraggable offset={topHiddenOffset} pageEmpty={!renderedBlocks || renderedBlocks.length == 0} onDragEnter={props.onDragEnter} />
            }
            {renderedBlocks}
            {
                props.editor &&
                <PageBottomHiddenDraggable onDragEnter={props.onDragEnter} />
            }
        </React.Fragment>
    );
    const contentProps = {
        className,
        id: props.id,
        style: containerStyle,
        onDragOver: (e) => { if (e) { e.preventDefault() } },
        onDrop: props.onDrop
    }
    if (props.onContent) {
        content = props.onContent(content, style, contentProps);
    } else {
        Utilities.copyObject(style, contentProps.style);
    }
    if (props.contentProps) {
        for (let key in props.contentProps) {
            switch (key) {
                case 'backgroundColor':
                case 'style':
                    break;
                default:
                    contentProps[key] = props.contentProps[key];
                    break;
            }
        }
    }
    // Utilities.copyObject(props.contentProps, contentProps);
    if (!props.editor && props.link) {
        return <a href={props.link} target={props.newWindow ? '_blank' : undefined} {...contentProps}>{content}</a>
    } else if (props.isForm) {
        return <form {...contentProps}>{content}</form>
    }
    return <div {...contentProps}>{content}</div>
}
const EditorContainer = withBlockRendering(_EditorContainer);

function EditorContainerWrapper(props) {
    return (
        <div className={props.wrapperClassName} id={props.id} style={props.style ? { backgroundColor: props.style.backgroundColor } : undefined} onDragOver={props.onDragOver} onDrop={props.onDrop}>
            <div className={props.className} style={props.style}>{props.children}</div>
        </div>
    );
}

export {
    Builder,
    BuilderBlock,
    BuilderControls,
    BuilderPagerControls,
    EditorContainer,
    EditorContainerWrapper,
    EmptyContentPlaceholder,
    EmptyPlaceholder,
    PageBottomHiddenDraggable,
    PageTopHiddenDraggable
};